import { render, staticRenderFns } from "./on-addprod.vue?vue&type=template&id=74143440"
import script from "./on-addprod.vue?vue&type=script&lang=js"
export * from "./on-addprod.vue?vue&type=script&lang=js"
import style0 from "./on-addprod.vue?vue&type=style&index=0&id=74143440&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports